module.exports = __webpack_public_path__ + "static/media/country_mo.29d5d4a8.webp";